export default "__VITE_ASSET__BmdiV4Wx__"